/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import {error} from '@ion/core/src/logger/logger';
import globalSearch from '@ion/core/src/services/GlobalSearch';
import {SearchType} from '@ion/core/src/types/services';
import {getAccountIds} from '../helpers';

export const GLOBAL_SEARCH_REQUEST  = 'GLOBAL_SEARCH_REQUEST';
export const GLOBAL_SEARCH_RESPONSE = 'GLOBAL_SEARCH_RESPONSE';
export const GLOBAL_SEARCH_ERROR    = 'GLOBAL_SEARCH_ERROR';
export const SET_TOP_SHEET_STATUS   = 'SET_TOP_SHEET_STATUS';

/**
 * @search
 */
export const search = (searchTerm: string) => {
  return async(dispatch, getState) => {
    dispatch({type: GLOBAL_SEARCH_REQUEST, searchTerm});
    const accountIds = getAccountIds(getState);
    try {
      const {assets, drivers, geofences, places} = await globalSearch({
        types : [
          SearchType.asset,
          SearchType.driver,
          SearchType.geofence,
          SearchType.place
        ],
        useCVS         : true,
        useHereApi     : true,
        showMatchLevel : true,
        searchTerm,
        accountIds
      });
      dispatch({type: GLOBAL_SEARCH_RESPONSE, assets, drivers, geofences, places});
    } catch (err) {
      error(err);
      dispatch({type: GLOBAL_SEARCH_ERROR, error: err});
    }
  };
};

/**
 * @setTopSheetStatus
 */
export const setTopSheetStatus = data => (
  {type: SET_TOP_SHEET_STATUS, data}
);
